module.exports = __webpack_public_path__ + "img/wx.028feffe.png";